import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice";
import confReducer from "./features/confirmationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    conf: confReducer,
  },
});
